// extracted by mini-css-extract-plugin
module.exports = {"column":"supply-column_column__266gB","buttonWrapper":"supply-column_buttonWrapper__2VqDY"};